var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.visible)?_c('div',{staticClass:"cardview",class:[
    `bg-${_vm.bgColor}`,
    {
      'cardview--active': _vm.item.active,
    },
    _vm.itemClass,
  ],on:{"click":function($event){return _vm.$emit('selected', { ..._vm.item })}}},[_c('div',{staticClass:"d-flex mb-2"},[_c('span',{staticClass:"cardview__count",class:`color-${_vm.color}`},[_vm._v(" "+_vm._s(_vm.item.count)+" ")]),(_vm.icon)?_c('img',{attrs:{"src":_vm.icon}}):_c('em',{class:`fa fa-circle color-${_vm.color}`})]),_c('div',[_c('span',{staticClass:"font-12 font-weight-bold color-dark-blue d-block"},[_vm._v(" "+_vm._s(_vm.$t('Status.HeaderText'))+" ")]),_c('span',{staticClass:"cardview__title",class:`color-${_vm.color}`},[_vm._v(" "+_vm._s(_vm.title)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }